const GTM_CLICK_IGNORE_ATTRIBUTE = 'data-gtm-click-ignore';
const GTM_CLICK_ATTRIBUTE = 'data-gtm-click';
const GTM_PUSH_ATTRIBUTE = 'data-gtm-push';

window.dataLayer = window.dataLayer || [];

const { dataLayer } = window;

const isValidTrackingObject = (data = {}) => data && Object.hasOwn(data, 'event');

const createGtmPushData = (event, category, action, obj) => ({
	event,
	events: {
		category,
		action,
	},
	...obj,
});

const removeNullObjectValues = (obj) =>
	Object.entries(obj).forEach(([key, val]) => {
		if (val && typeof val === 'object') {
			removeNullObjectValues(val);
		} else if (val === null) {
			delete obj[key];
		}
	});

const getTrackingData = (el) => {
	try {
		const json = el.getAttribute(GTM_PUSH_ATTRIBUTE);
		const obj = JSON.parse(json);

		removeNullObjectValues(obj);

		return obj;
	} catch {
		return {};
	}
};

const pushTrackingData = (data = {}) => {
	if (!isValidTrackingObject(data)) {
		return false;
	}

	dataLayer.push(data);

	return true;
};

const isExternalLink = (link, origin = window.location.origin) => {
	const absoluteUrl = new URL(link, origin);
	const isExternal = absoluteUrl.origin !== origin;

	return isExternal;
};

const attributes = {
	GTM_CLICK_IGNORE_ATTRIBUTE,
	GTM_CLICK_ATTRIBUTE,
	GTM_PUSH_ATTRIBUTE,
};

export { attributes, createGtmPushData, pushTrackingData, getTrackingData, isExternalLink, isValidTrackingObject };
